<template>
  <div class="CopiedFromOrderBanner type-xs">
    <div class="flex justify-center items-center bg-bg-attention">
      <div class="flex flex-row flex-wrap gap-8 justify-between w-full p-12">
        <div class="items-center gap-6 flex">
          <img
            src="/icons/info.svg"
            class="w-16 h-16"
            alt=""
          >
          {{ $t('siteNotice.editingOrder') }} #{{ orderId }}
        </div>
        <div class="btn--text btn--sm" @click="clearEditingOrder">
          {{ $t('checkout.orderProposal.cancel') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useCartStore } from '~/store/cart';
import { useUiStore } from '~/store/ui';

const cartStore = useCartStore();
const uiStore = useUiStore();

const emit = defineEmits(['closeMenu']);

defineProps<{
  orderId: string;
}>();

const clearEditingOrder = async() => {
  cartStore.deleteCart();
  uiStore.closeAllModal();
  emit('closeMenu');
};

</script>
